import React from 'react';
import { Link, Typography } from '@mui/material';
import { PaymentMethodVerificationEventPropsEventFragment } from '#types';
import { gql } from '@apollo/client';
import { FlattenedUser } from '../../../types/user';

export const paymentMethodVerificationEventPropsEventFragment = gql`
	fragment paymentMethodVerificationEventPropsEvent on Event {
		id
		category
		message
		referenceID
		actingUser {
			id
		}
	}
`;

export const getPaymentMethodVerificationEventProps = (
	eventProps: {
		event: PaymentMethodVerificationEventPropsEventFragment;
		message: React.JSX.Element;
		links: {
			type: string;
			text: string;
			link: any;
			onClick?: ( () => any ) | null;
		}[];
		icon: string;
		className: string;
	},
	user: FlattenedUser
) => {
	const { event } = eventProps;

	// Assume actingUser is the effectedUser as specified
	const isEffectedUser =
		user?.isLoggedIn && event.actingUser?.id === user.user.id;

	if ( !isEffectedUser || !event.message ) {
		// If user is not the effected user, don't show this event
		return {
			...eventProps,
			message: null,
		};
	}

	// Transform referenceID to date
	const referenceIdAsInt = parseInt( event.referenceID || '0', 10 );
	const microdepositDate = new Date( referenceIdAsInt * 100 );
	const now = new Date();

	// Transform message into a link
	const messageLink = (
		<Link href={ event.message } target='_blank' rel='noopener noreferrer'>
			here
		</Link>
	);

	let message: React.JSX.Element;

	if ( microdepositDate <= now ) {
		// Microdeposits are available now
		message = (
			<Typography>
				Your bank account has been paid microdeposits for verification, click{ ' ' }
				{ messageLink } to verify that now.
			</Typography>
		);
	} else {
		// Microdeposits will be available in the future
		const dateAndTimeStamp = microdepositDate.toLocaleString();
		message = (
			<Typography>
				Your bank account requires verification. The microdeposits will be
				available on { dateAndTimeStamp }. Click { messageLink } to take care of
				that once you get them.
			</Typography>
		);
	}

	return {
		...eventProps,
		icon: 'warning',
		message,
		links: [
			{
				type: 'primary',
				text: 'Verify',
				link: { href: event.message },
			},
		],
	};
};
